import { Box, styled } from "@mui/material";
import { white, bgLightSky, borderLightBlue } from "../../constants/colors";

export const MainContent = styled("div")({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  backgroundColor: bgLightSky,
});

export const ScrollableContent = styled("section")({
  flexGrow: 1,
  padding: "0 16px",
});

export const OverviewRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px",
  padding: "0",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    alignItems: "stretch",
    gap: "10px",
    height: "auto",
  },
}));

export const ChartLabelContainer = styled(Box)({
  position: "absolute",
  textAlign: "center",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "4px",
});

export const StatusCard = styled(Box)(({ color }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  border: `1px solid ${borderLightBlue}`,
  borderRadius: "8px",
  padding: "12px 16px",
  minHeight: "50px",
  backgroundColor: white,
  position: "relative",
  overflow: "hidden",
  paddingLeft: "22px",
  "&::before": {
    content: '""',
    position: "absolute",
    width: "6px",
    height: "100%",
    left: 0,
    top: 0,
    backgroundColor: color,
    borderRadius: "8px 0px 0px 8px",
  },
}));
